import {
  KdsBadgeNotification,
  KdsButton,
} from "@kazaar-platform/design-system";
import { RiSurveyLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { type HeaderWorklistProps } from "./HeaderWorklist.types";

export const HeaderWorklist = ({
  nbOfActions,
  isOpen,
  setIsOpen,
}: HeaderWorklistProps) => {
  const { t } = useTranslate();

  return (
    <div className="relative flex gap-x-2">
      <KdsButton
        id="worklistButton"
        variant="outlined"
        size="medium"
        onPress={() => setIsOpen(!isOpen)}
        iconLeft={RiSurveyLine}
        color="neutral"
      >
        {t("navigation.order.worklist")}
      </KdsButton>
      <div className="absolute right-[-8px] top-[-8px]">
        <KdsBadgeNotification type="error" value={nbOfActions} />
      </div>
    </div>
  );
};
